module.exports = __webpack_public_path__ + "static/media/magic_book.05fc6856.jpeg";